import { supabase } from "../constants";

// ─── CV: enlaces firmados ─────────────────────────────────────────────────────
// El bucket `cvs` es privado. `candidates.cv_url` guarda la RUTA del archivo
// dentro del bucket (`{id}.pdf`, `intake/{uuid}.pdf`); las filas antiguas
// pueden tener todavía la URL pública completa, y por eso todo lo que lee pasa
// por la ruta de servidor /api/cv-url, que entiende los dos formatos.
//
// Nunca se guarda ni se reparte un enlace firmado: caduca en una hora. Se
// pide en el momento de usarlo.

// Enlace firmado al CV de un candidato, o null si no tiene. Lanza un error con
// mensaje legible si la ruta falla, para que la pantalla lo pueda decir.
export const getCvSignedUrl = async (candidateId) => {
  const { data: { session } } = await supabase.auth.getSession();
  const jwt = session?.access_token;
  if (!jwt) throw new Error("No session");
  const r = await fetch(`/api/cv-url?candidateId=${encodeURIComponent(candidateId)}`, { headers: { Authorization: `Bearer ${jwt}` } });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data.url || null;
};

// Sube un CV como admin a `{candidateId}.{ext}` y devuelve la ruta que se
// guarda en cv_url. Reemplaza el anterior si existía (necesita la regla
// UPDATE de admin sobre `cvs`).
export const uploadCandidateCv = async (candidateId, file) => {
  const ext = (file.name.split(".").pop() || "pdf").toLowerCase();
  const path = `${candidateId}.${ext}`;
  const { error } = await supabase.storage.from("cvs").upload(path, file, { upsert: true, contentType: file.type || "application/pdf" });
  if (error) throw error;
  return path;
};
